var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstructoravatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 143,
    height: 143,
    viewBox: "0 0 143 143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "instructor_avatar"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3241",
    "data-name": "Ellipse 3241",
    cx: 46,
    cy: 46,
    r: 46,
    transform: "translate(1306 24)",
    fill: "#a5a2b4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instructor_avatar",
    "data-name": "instructor avatar",
    transform: "translate(15373 13672)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "julian-wan-WNoLnJo7tS8-unsplash",
    cx: 71.5,
    cy: 71.5,
    r: 71.5,
    transform: "translate(-15373 -13672)",
    fill: "#efeff6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_850",
    "data-name": "Mask Group 850",
    transform: "translate(-16653 -13670)",
    opacity: 0.5,
    clipPath: "url(#instructor_avatar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-09-18T134021.714",
    "data-name": "svgexport-6 - 2022-09-18T134021.714",
    transform: "translate(1310.819 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16102",
    "data-name": "Group 16102",
    transform: "translate(17.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16101",
    "data-name": "Group 16101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28294",
    "data-name": "Path 28294",
    d: "M30.112,0a23.86,23.86,0,1,0,23.86,23.86A23.924,23.924,0,0,0,30.112,0Z",
    transform: "translate(-6.251)",
    fill: "#a5a2b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16104",
    "data-name": "Group 16104",
    transform: "translate(0 49.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16103",
    "data-name": "Group 16103"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28295",
    "data-name": "Path 28295",
    d: "M83.448,31.345a22.244,22.244,0,0,0-2.4-4.376,29.658,29.658,0,0,0-20.526-12.92,4.392,4.392,0,0,0-3.022.729,25.1,25.1,0,0,1-15,4.9,25.1,25.1,0,0,1-15-4.9,3.909,3.909,0,0,0-3.022-.729A29.443,29.443,0,0,0,3.949,26.968a25.647,25.647,0,0,0-2.4,4.376,2.216,2.216,0,0,0,.1,1.98,41.568,41.568,0,0,0,2.813,4.168A39.6,39.6,0,0,0,9.262,42.91a62.455,62.455,0,0,0,4.793,4.168,47.515,47.515,0,0,0,56.681,0,45.813,45.813,0,0,0,4.793-4.168,48.113,48.113,0,0,0,4.793-5.418,36.529,36.529,0,0,0,2.813-4.168A1.778,1.778,0,0,0,83.448,31.345Z",
    transform: "translate(-1.363 -13.984)",
    fill: "#a5a2b4"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructoravatar);
export default __webpack_public_path__ + "static/media/instructor avatar.edab152931bfb8af51f2693dcda98725.svg";
export { ForwardRef as ReactComponent };